import React from 'react';
import {
  CalendarIcon,
  Divider,
  EyeIcon,
  Flex,
  ProviderConsumer as FluentUIThemeConsumer,
  Text,
  Tooltip
} from '@fluentui/react-northstar';
import { Link } from '@fluentui/react';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { ConvertDateToLocale } from '../../../shared/common/ConvertDate';
import AffectedUserIcon from '../../../../svg/Affected-user-request.svg';

interface Props {
  ticket: Ticket;
  view?: 'list' | 'edit';
  userId: number;
}

const isAffectedUser = (ticket,userId) => ticket.AffectedUsers?.some(x=>x.PlatformUserId == userId);

export const RequestCardFooter = ({ ticket, view = 'list', userId }: Props) => {
  const {t} = useTranslation();
  return (
  <FluentUIThemeConsumer
    render={globalTheme => (
      <>
        <Divider size={0} className={`mb-2`} />
        <Flex vAlign="center" space="between">
          <Flex vAlign="center">
            <span style={{ marginBottom: '4px' }} className={`inline`}>
              <CalendarIcon style={{ color: '#8f90a6' }} />
            </span>
            <Text size="small" className={`text-gray-500 ml-1`} content={`${t('requests.last-modified')}:`} />
            <Text size="small" className={`ml-1`} content={ConvertDateToLocale(ticket.ModifiedDate, DateTime.DATETIME_MED)} />
          </Flex>
          {view === 'list' ? (
            <Flex>
              {isAffectedUser(ticket, userId) && (
                <Link to={`/requests/${ticket.Id}`} className={`hover:no-underline py-1 mr-2 cursor-pointer`} style={{ color: globalTheme.siteVariables.colorScheme.brand.foreground }}> 
                  <Tooltip trigger={<Text size="small" weight="semibold" content={<Flex vAlign="center"><AffectedUserIcon /></Flex>} />} content={t('requests.affected-user')} />
                </Link>
              )}
             <Link to={`/requests/${ticket.Id}`} className={`hover:no-underline py-1 cursor-pointer`} style={{ color: globalTheme.siteVariables.colorScheme.brand.foreground }}>
                <Text size="small" weight="semibold" content={
                  <Flex vAlign="center">
                    <EyeIcon size="small" />
                    <span className={`ml-1`}>{t('requests.view-ticket')}</span>
                  </Flex>} />
              </Link>
            </Flex>
          ) : (
            ''
          )}
        </Flex>
      </>
    )}
  />
)};
